import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = '/api';

const SelecionarIgreja = ({ user, onIgrejaSelecionada, onLogout }) => {
  const [igrejas, setIgrejas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadIgrejas();
  }, []);

  const loadIgrejas = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('ebd_token');

      // Buscar igrejas que o usuário tem acesso
      const response = await axios.get(`${API}/igrejas`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Filtrar apenas igrejas ativas (garantir que desativadas não apareçam)
      const igrejasAtivas = response.data.filter(igreja => igreja.ativa !== false);
      setIgrejas(igrejasAtivas);

      // Se tiver apenas 1 igreja, seleciona automaticamente
      if (igrejasAtivas.length === 1) {
        handleSelecionarIgreja(igrejasAtivas[0]);
      }

    } catch (err) {
      console.error('Erro ao carregar igrejas:', err);
      setError('Erro ao carregar igrejas. Tente fazer login novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelecionarIgreja = (igreja) => {
    // Verificar se a igreja está ativa antes de permitir seleção
    if (!igreja.ativa) {
      alert('Esta igreja está desativada. Entre em contato com o administrador.');
      return;
    }

    // Salvar igreja selecionada no localStorage
    localStorage.setItem('ebd_igreja_id', igreja.id);
    localStorage.setItem('ebd_igreja_nome', igreja.nome);
    localStorage.setItem('ebd_igreja_data', JSON.stringify(igreja));

    // Notificar componente pai
    onIgrejaSelecionada(igreja);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando igrejas...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md">
          <div className="text-center">
            <div className="text-red-500 text-5xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Erro</h2>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={onLogout}
              className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Fazer Login Novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Selecione a Igreja
          </h1>
          <p className="text-gray-600">
            Olá, <span className="font-semibold">{user?.nome}</span>! Você tem acesso a {igrejas.length} {igrejas.length === 1 ? 'igreja' : 'igrejas'}.
          </p>
        </div>

        {/* Lista de Igrejas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          {igrejas.map((igreja) => (
            <div
              key={igreja.id}
              onClick={() => handleSelecionarIgreja(igreja)}
              className="bg-gradient-to-br from-blue-50 to-purple-50 border-2 border-blue-200 rounded-lg p-6 cursor-pointer hover:border-blue-500 hover:shadow-lg transition-all transform hover:scale-105"
            >
              <div className="flex items-start space-x-4">
                {/* Logo ou Ícone */}
                <div className="flex-shrink-0">
                  {igreja.logo_url ? (
                    <img
                      src={igreja.logo_url}
                      alt={igreja.nome}
                      className="w-16 h-16 rounded-full object-cover border-2 border-blue-300"
                    />
                  ) : (
                    <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                      {igreja.nome.charAt(0)}
                    </div>
                  )}
                </div>

                {/* Informações */}
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-800 mb-1">
                    {igreja.nome}
                  </h3>
                  <p className="text-sm text-gray-600 mb-2">
                    CNPJ: {igreja.cnpj}
                  </p>

                  <div className="space-y-1 text-xs text-gray-500">
                    <p>👔 {igreja.presidente}</p>
                    <p>⛪ {igreja.pastor}</p>
                    <p>📖 {igreja.superintendente_ebd}</p>
                  </div>

                  {/* Valor Mensal */}
                  <div className="mt-3">
                    <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                      R$ {typeof igreja.valor_mensal === 'number' ? igreja.valor_mensal.toFixed(2).replace('.', ',') : (igreja.valor_mensal || 0).toFixed(2).replace('.', ',')}/mês
                    </span>
                  </div>
                </div>

                {/* Seta */}
                <div className="flex-shrink-0 text-blue-500 text-2xl">
                  →
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Botão Logout */}
        <div className="text-center pt-4 border-t">
          <button
            onClick={onLogout}
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            ← Sair e fazer login com outra conta
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelecionarIgreja;
